module.exports = __webpack_public_path__ + "img/tyh2.469b2c6b.jpg";